import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=184fe99a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184fe99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184fe99a')) {
      api.createRecord('184fe99a', component.options)
    } else {
      api.reload('184fe99a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=184fe99a&scoped=true&", function () {
      api.rerender('184fe99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KnawlZAYic12/JS/comp/SearchFilterTokens.vue"
export default component.exports